import type { Components } from '@mui/material/styles';

export default function MuiRadioGroup(): Components['MuiRadioGroup'] {
  return {};
}
